import React from 'react';
import './SessionExpired.css';

function SessionExpired() {
  return (
    <div className="session-expired">
      <div className="session-expired-card">
        <h2>Your session has ended</h2>
        <p>
          You were signed out after a period of inactivity. Close this tab and
          open Document Builder again from your main CemSites platform.
        </p>
      </div>
    </div>
  );
}

export default SessionExpired;
